(function () {
  'use strict';
  if (new URLSearchParams(window.location.search).get('ayrd_account_landing') !== '1') return;
  var script = document.currentScript;
  var accountUrl = script && script.dataset.accountUrl || '/account';
  var vehicleUrl = 'https://account.ayrdauto.com/pages/01a14124-8bdf-7da1-adcb-5b1713a426a0';
  var cleanUrl = new URL(window.location.href);
  cleanUrl.searchParams.delete('ayrd_account_landing');
  window.history.replaceState(null, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
  var controller = new AbortController();
  var timer = setTimeout(function () { controller.abort(); }, 5000);
  fetch('/apps/ayrd-garage/profile', {credentials: 'same-origin', cache: 'no-store', signal: controller.signal})
    .then(function (response) {
      if (!response.ok) throw new Error('Account unavailable');
      return response.json();
    })
    .then(function (profile) {
      window.location.replace(profile.signed_in === true && Array.isArray(profile.vehicles) && profile.vehicles.length ? vehicleUrl : accountUrl);
    })
    .catch(function () { window.location.replace(accountUrl); })
    .finally(function () { clearTimeout(timer); });
}());
